import {Injectable} from '@angular/core';
import {HttpService} from 'src/app/services/http.service';
import {Observable, Subject} from 'rxjs';
import {CountryModel} from '../shared/models/CountryModel';
import {FieldSetModel} from './client-bank-account-validation.service';

@Injectable({
  providedIn: 'root'
})
export class ClientBankAccountHelperDataService {
  public OTHER_BANK_CODE = 999;
  private getCountriesUrl = 'countries';
  private getBankAccountFieldsUrl = 'bankaccountvalidation/getbankaccountfields?countryCode=';
  private ilBanks: any[];

  private errorOccurred = new Subject<string>();
  public onErrorOccured: Observable<string>;

  private countryChanged = new Subject<CountryModel>();
  public onCountryChanged: Observable<CountryModel>;

  public ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private http: HttpService) {
    this.onErrorOccured = this.errorOccurred.asObservable();
    this.onCountryChanged = this.countryChanged.asObservable();

    this.ilBanks = [
      {code: '18', name: '18 - וואן זירו הבנק הדיגיטלי - One Zero Bank'},
      {code: '12', name: '12 - בנק הפועלים - Hapoalim Bank'},
      {code: '10', name: '10 - בנק לאומי - Leumi Bank'},
      {code: '11', name: '11 - בנק דיסקונט - Discount Bank'},
      {code: '20', name: '20 - בנק מזרחי טפחות - Mizrahi-Tefahot Bank'},
      {
        code: '31',
        name: '31 - בנק הבינלאומי הראשון - First International bank of Israel'
      },
      {code: '13', name: '13 - בנק איגוד - Union Bank'},
      {
        code: '17',
        name: '17 - בנק מרכנתיל דיסקונט - Discount Mercantile Bank'
      },
      { code: '4', name: '4 - בנק יהב - Yahav Bank' },
      { code: '14', name: '14 - בנק אוצר החייל - Otsar Ha-Hayal Bank' },
      { code: '54', name: '54 - בנק ירושלים - Bank of Jerusalem' },
      { code: '68', name: '68 - בנק דקסיה ישראל - Dexia Israel Bank' },
      { code: '34', name: '34 - בנק ערבי ישראלי - Arab Israel Bank' },
      { code: '46', name: '46 - בנק מסד - Bank Massad' },
      {
        code: '52',
        name: '52 - (בנק פועלי אגודת ישראל (פאג"י - Poaley Agudat Israel Bank'
      },
      {code: '9', name: '9 - בנק הדואר - Bank Post'},
      {code: '26', name: '26 - בנק יובנק - UBank'},
      {code: '22', name: '22 - סיטי-בנק - Citibank'},
      {code: '23', name: '23 - HSBC Bank'},
      {
        code: '39',
        name: '39 - סטייט בנק אוף אינדיה - SBI State Bank of India'
      }
    ];
  }

  public emitErrorOccurred(error: string) {
    this.errorOccurred.next(error);
  }

  public emitCountryChanged(country: CountryModel) {
    this.countryChanged.next(country);
  }

  public getCountries(): Observable<any> {
    return this.http.get(this.getCountriesUrl);
  }

  public getBankAccountFields(countryCode: string): Observable<FieldSetModel[]> {
    return this.http.getTyped<FieldSetModel[]>(this.getBankAccountFieldsUrl + countryCode);
  }

  public getILBanks(): any[] {
    return this.ilBanks.sort((a, b) => {
        if (isNaN(a.code) || isNaN(b.code)) {
          return -1;
        }
        return +a.code - +b.code;
      }
    );
  }
}
